import {sortableContainer, sortableElement} from "react-sortable-hoc";
import i18next from "i18next";
import {Button, Input, InputNumber, Select, Table} from "antd";
import React, {useState} from "react";

const SortTable = ({selectedItems, setSelectedItems, items, setItems, itemsToSelect, renderSelected, order, setOrder,
                       handleAdd, getColumns, selectedValue, type, randomNum, setRandomNum}) => {

    const SortableItem = sortableElement((props) => <tr {...props} />);
    const SortableContainer = sortableContainer((props) => <tbody {...props} />);

    //const [randomNum, setRandomNum] = useState(generateRandomNumber());

    function generateRandomNumber() {
        const min = 30;
        const max = 100;
        const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return randomNumber;
    }

    function handleChange(value) {
        setRandomNum(value);
        setOrder(value);
    }

    function SortableTable() {

        //console.log("items", items)
        const merge = (a, b, i = 0) => {
            let aa = [...a];
            return [...a.slice(0, i), ...b, ...aa.slice(i, aa.length)];
        };
        const onSortEnd = ({oldIndex, newIndex}) => {
            let tempDataSource = items;

            if (oldIndex !== newIndex) {
                if (!selectedItems.length) {
                    let movingItem = tempDataSource[oldIndex];
                    tempDataSource.splice(oldIndex, 1);
                    tempDataSource = merge(tempDataSource, [movingItem], newIndex);
                } else {
                    let filteredItems = [];
                    selectedItems.forEach((d) => {
                        filteredItems.push(tempDataSource[d]);
                    });
                    let newData = [];
                    tempDataSource.forEach((d, i) => {
                        if (!selectedItems.includes(i)) {
                            newData.push(d);
                        }
                    });
                    tempDataSource = [...newData];
                    tempDataSource = merge(tempDataSource, filteredItems, newIndex);
                }
                setItems(tempDataSource);
                setSelectedItems([]);
            }
        };

        const DraggableContainer = (props) => (
            <SortableContainer
                useDragHandle
                disableAutoscroll
                helperClass="row-dragging"
                onSortEnd={onSortEnd}
                {...props}
            />
        );

        const DraggableBodyRow = ({className, style, ...restProps}) => {
            // function findIndex base on Table rowKey props and should always be a right array index
            const index = items.findIndex(
                (x) => x.index === restProps["data-row-key"]
            );
            return (
                <SortableItem
                    index={index}
                    {...restProps}
                    selected={selectedItems.length}
                    onClick={(e) => {
                        if (e.ctrlKey || e.metaKey) {
                            selectedItems.includes(index)
                                ? selectedItems.splice(selectedItems.indexOf(index), 1)
                                : selectedItems.push(index);
                            setSelectedItems(selectedItems);
                        } else {
                            setSelectedItems([]);
                        }
                    }}
                />
            );
        };

        let idDiv = "add" + type
        let lowerCase = type.toLowerCase()
        let heading = lowerCase + "s"

        const divStyle = {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        };

        return (
            <>
                <br/>
                <div style={divStyle}>
                    {/*<h2>{i18next.t('common.tools.edit.' + heading)}</h2>*/}
                    <Select
                        placement="topLeft"
                        allowClear
                        options={itemsToSelect}
                        style={{width: 180}}
                        placeholder={i18next.t('common.tools.edit.choose_' + lowerCase)}
                        id="clear"
                        value={selectedValue}
                        onChange={(value) => renderSelected(value)}/>

                    {/*<Input type={"number"} min={0} value={order} placeholder={i18next.t('common.tools.edit.order')}
                           onChange={e => setOrder(e.target.value)}
                           id="order-input"/>*/}
                    <InputNumber value={randomNum} onChange={handleChange} min={30} max={100} style={{visibility: 'hidden', width: '40px'}} />

                    <Button onClick={() =>
                        handleAdd()}
                            id="clear"
                            type="primary"
                            ghost>{i18next.t('common.tools.edit.add')}</Button>
                </div>
                <br/>
                <div id="tables">
                    <Table
                        pagination={{
                            defaultPageSize: 5,
                            showSizeChanger: true,
                            pageSizeOptions: ['5', '10', '20', '30']
                        }}
                        //pagination={false}
                        dataSource={items}
                        columns={getColumns()}
                        rowKey="index"
                        components={{
                            body: {
                                wrapper: DraggableContainer,
                                row: DraggableBodyRow
                            }
                        }}
                    />
                </div>
                {selectedItems.length ? <>{selectedItems.length} items selected </> : ""}
            </>
        );

    }

    return (
        <>
            {SortableTable()}
        </>
    )

}
export default SortTable;